import { render, staticRenderFns } from "./CensusSnapshot.vue?vue&type=template&id=1840000e&scoped=true&"
import script from "./CensusSnapshot.vue?vue&type=script&lang=js&"
export * from "./CensusSnapshot.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840000e",
  null
  
)

export default component.exports